import api from "./config/axios.config";

export const sendForgotPasswordEmail = async (email: string): Promise<void> => {
  await api.post("/sendMail/v2/forgot-password", { email }, {
    headers: { "Content-Type": "application/json" },
  });
};

export const completeResetPassword = async (
  codigoVerificacion: string,
  password: string,
  confirmPassword: string,
  token: string
): Promise<void> => {
  await api.post(
    "/sendMail/v2/reset-password/complete",
    { codigoVerificacion, password, confirmPassword },
    { headers: { "x-verification-token": token } }
  );
};

export const completeActivatePassword = async (
  codigoVerificacion: string,
  password: string,
  confirmPassword: string,
  token: string
): Promise<void> => {
  await api.post(
    "/sendMail/v2/activate/complete",
    { codigoVerificacion, password, confirmPassword },
    { headers: { "x-verification-token": token } }
  );
};

const passwordService = { sendForgotPasswordEmail, completeResetPassword, completeActivatePassword };
export default passwordService;
